import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import SideBar from './components/partials/SideBar';
import NavBar from './components/partials/NavBar';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <div className="layout-wrapper layout-content-navbar">
    <div className="layout-container">
      {/* <SideBar/> */}
      <div className="layout-page">
        {/* <NavBar/> */}
        <div className="content-wrapper">
          {/* <div className="container-xxl flex-grow-1 container-p-y"> */}
            <BrowserRouter>
              <App />
            </BrowserRouter>
          {/* </div> */}
        </div>
      </div>
    </div>
  </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
 